// SEO metadata configurations for each page

export const seoData = {
  home: {
    title: "Automated Reporting on Real Estate Projects",
    description:
      "Estabild provides intelligent reporting and project management solutions for real estate development. Streamline workflows, automate reporting, and gain real-time visibility into project performance.",
    keywords:
      "real estate project management, construction project management, automated reporting, project tracking, real estate development software, construction software, project management platform",
    url: "/",
  },
  funding: {
    title: "Funding Solutions for Real Estate Projects",
    description:
      "Streamline funding processes for real estate development projects. Centralize project data, enable performance-based payouts, and improve capital efficiency with Estabild's funding solutions.",
    keywords:
      "real estate funding, construction funding, project financing, capital management, real estate investment, funding automation",
    url: "/solutions/funding",
  },
  execution: {
    title: "Project Execution Management",
    description:
      "Manage real estate project execution with real-time tracking, automated reporting, and centralized project data. Improve collaboration and ensure project success with Estabild.",
    keywords:
      "project execution, construction management, project tracking, real estate execution, project monitoring, construction execution",
    url: "/solutions/execution",
  },
  planning: {
    title: "Real Estate Project Planning Solutions",
    description:
      "Plan and organize real estate development projects effectively. Manage activities, tasks, communication, and project files in one centralized platform with Estabild.",
    keywords:
      "project planning, real estate planning, construction planning, project organization, real estate development planning",
    url: "/solutions/planning",
  },
  invoiceHandling: {
    title: "Invoice Handling & Management",
    description:
      "Streamline invoice collection, review, and processing for real estate projects. Automate invoice workflows and improve financial management with Estabild.",
    keywords:
      "invoice management, invoice processing, construction invoicing, real estate invoicing, invoice automation",
    url: "/solutions/invoice-handling",
  },
  about: {
    title: "About Estabild",
    description:
      "Learn about Estabild, a leading provider of project management and reporting solutions for real estate development projects. Discover our mission, values, and team.",
    keywords:
      "about Estabild, Estabild company, real estate software company, project management company",
    url: "/about",
  },
  pricing: {
    title: "Pricing Plans",
    description:
      "Explore Estabild's pricing plans for real estate project management solutions. Contact us for a custom quote tailored to your project needs.",
    keywords:
      "Estabild pricing, project management pricing, real estate software pricing, construction software cost",
    url: "/pricing",
  },
  contact: {
    title: "Contact Us - Book a Demo",
    description:
      "Get in touch with Estabild to learn how we can help streamline your real estate project management. Schedule a demo or contact our team today.",
    keywords:
      "contact Estabild, Estabild demo, real estate software demo, project management consultation",
    url: "/contact",
  },
  privacy: {
    title: "Privacy Policy",
    description:
      "Read Estabild's privacy policy to understand how we collect, use, and protect your personal information.",
    keywords: "Estabild privacy policy, data protection, privacy",
    url: "/privacy",
  },
  terms: {
    title: "Terms of Service",
    description:
      "Review Estabild's terms of service to understand the terms and conditions for using our platform.",
    keywords: "Estabild terms of service, terms and conditions",
    url: "/terms",
  },
  security: {
    title: "Security & Compliance",
    description:
      "Learn about Estabild's security measures, data protection, and compliance standards to ensure your project data is safe and secure.",
    keywords:
      "Estabild security, data security, project management security, compliance",
    url: "/security",
  },
};


